<template>
  <div v-if="project" class="project-details-mobile-container">
    <div class="go-back" @click="$router.go(-1)"><i class="fa fa-chevron-left"/></div>
    
    <div class="details">

      <div class="project-name">{{ project.name }}</div>
      <div class="created">Created {{ new Date(project.created).toLocaleDateString() }}</div>

      <div class="separator"/>

      <div class="navigation">
        <div class="gallery" @click="gotoGallery()">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20" style="position:relative; top: 3px;"><g><path d="M23.6 0.1L3.8 0.1C3.4 0.1 3 0.4 3 0.9L3 3.1 0.8 3.1C0.3 3.1 0 3.5 0 3.9L0 19.1C0 19.6 0.3 19.9 0.8 19.9L20.6 19.9C21 19.9 21.3 19.6 21.3 19.1L21.3 16.9 23.6 16.9C24 16.9 24.4 16.5 24.4 16.1L24.4 0.9C24.4 0.4 24 0.1 23.6 0.1ZM19.8 4.7L19.8 16.7 15.7 13.2C15.5 13 15.1 13 14.9 13.2L11.6 15.1 6.7 9.5C6.5 9.3 6.3 9.2 6.1 9.2 5.9 9.2 5.7 9.3 5.6 9.5L1.5 13.5 1.5 4.7 19.8 4.7ZM1.5 15.7L6.1 11.1 10.9 16.6C11.1 16.9 11.5 16.9 11.8 16.8L15.2 14.7 19.4 18.4 1.5 18.4 1.5 15.7ZM22.9 15.3L21.3 15.3 21.3 3.9C21.3 3.5 21 3.1 20.6 3.1L4.6 3.1 4.6 1.6 22.9 1.6 22.9 15.3Z"/><path d="M15.6 11.5C17.1 11.5 18.3 10.3 18.3 8.9 18.3 7.4 17.1 6.2 15.6 6.2 14.2 6.2 13 7.4 13 8.9 13 10.3 14.2 11.5 15.6 11.5ZM15.6 7.7C16.3 7.7 16.8 8.2 16.8 8.9 16.8 9.5 16.3 10 15.6 10 15 10 14.5 9.5 14.5 8.9 14.5 8.2 15 7.7 15.6 7.7Z"/></g></svg>
          Gallery
        </div>
        <div class="presenter" @click="gotoPresenterView()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="position:relative; top: 6px;"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
          Presenter
        </div>
      </div>

      <div class="separator"/>

      <div class="contact">
        <div class="contact-header" @click="updateContact = true">
          Contact Details
          <div class="edit-contact-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
          </div>
        </div>
        <div class="contact-name contact-item">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:none;stroke-linejoin:round;stroke-width:2;stroke:currentColor"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </div>
          <div class="content">
            <div class="label">Name</div>
            <div class="value">{{ project.contact.name || 'Contact Name' }}</div>
          </div>
        </div>
        <div class="contact-email contact-item">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17"><g><g style="stroke-width:0.3;stroke:#000"><path d="M3.1 1C2 1 1 2 1 3.2L1 14.3C1 15.5 2 16.5 3.1 16.5L21.4 16.5C22.6 16.5 23.5 15.5 23.5 14.3L23.5 3.2C23.5 2 22.6 1 21.4 1L3.1 1ZM3.1 2.1L21.4 2.1C21.5 2.1 21.7 2.1 21.8 2.2L12.9 10.4C12.5 10.7 12 10.7 11.6 10.4L2.7 2.2C2.8 2.1 3 2.1 3.1 2.1L3.1 2.1ZM2.1 3.1L8.4 8.9 2.2 14.9C2.1 14.7 2.1 14.5 2.1 14.3L2.1 3.2C2.1 3.2 2.1 3.1 2.1 3.1L2.1 3.1ZM22.4 3.1C22.4 3.1 22.4 3.2 22.4 3.2L22.4 14.3C22.4 14.5 22.4 14.7 22.3 14.9L16.2 8.9 22.4 3.1ZM15.4 9.6L21.4 15.5 21.4 15.5 3.1 15.5 3.1 15.5 9.2 9.6 10.9 11.2C11.7 11.9 12.9 11.9 13.7 11.2L15.4 9.6Z"/></g></g></svg>
          </div>
          <div class="content">
            <div class="label">Email</div>
            <div class="value">
              <a :href="'mailto:'+project.contact.email">{{ project.contact.email || 'Contact Email' }}</a>
            </div>
          </div>
        </div>
        <div class="contact-phone contact-item">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 25"><g><g style="stroke-width:0.5;stroke:#000"><path d="M17.7 24.7C14.6 24.7 11.1 22.7 6.7 18.3 3.9 15.5 2 13 1 10.8 -0.3 7.6 0 5 2.1 2.8 2.8 2 4.1 0.9 4.1 0.8 4.5 0.5 5.1 0.3 5.6 0.3 6.2 0.3 6.7 0.5 7.1 0.9L10.5 4.2C10.9 4.6 11.1 5.1 11.1 5.7 11.1 6.3 10.9 6.8 10.5 7.2L9 8.7C8.8 8.9 8.7 9.1 8.7 9.4 8.7 9.7 8.8 9.9 9 10.1L14.9 16C15.1 16.2 15.3 16.3 15.6 16.3 15.9 16.3 16.1 16.2 16.3 16L17.8 14.5C18.2 14.2 18.7 13.9 19.3 13.9 19.9 13.9 20.4 14.2 20.8 14.5L24.1 17.9C25 18.7 25 20.1 24.1 20.9 24.1 20.9 23.1 22 22.2 22.9 20.9 24.1 19.4 24.7 17.7 24.7L17.7 24.7ZM5.6 1.4C5.4 1.4 5.1 1.5 4.9 1.7 4.9 1.7 3.6 2.9 2.9 3.6 1.2 5.4 0.9 7.6 2.1 10.3 3 12.4 4.8 14.8 7.5 17.5 11.7 21.7 14.9 23.6 17.7 23.6 19.1 23.6 20.3 23.1 21.4 22 22.3 21.2 23.3 20.1 23.3 20.1 23.7 19.7 23.7 19.1 23.3 18.7L20 15.3C19.8 15.2 19.6 15.1 19.3 15.1 19 15.1 18.8 15.2 18.6 15.3L17.1 16.8C16.7 17.2 16.2 17.4 15.6 17.4 15 17.4 14.5 17.2 14.1 16.8L8.2 10.9C7.8 10.5 7.6 10 7.6 9.4 7.6 8.8 7.8 8.3 8.2 7.9L9.7 6.4C9.8 6.2 10 6 10 5.7 10 5.4 9.8 5.2 9.7 5L6.3 1.7C6.2 1.5 5.9 1.4 5.6 1.4L5.6 1.4Z"/></g></g></svg>
          </div>
          <div class="content">
            <div class="label">Phone</div>
            <div class="value">{{ project.contact.phone || 'Contact Phone' }}</div>
          </div>
        </div>
      </div>

      <div class="separator"/>

      <div class="links">
        <div class="links-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 26" style="position:relative;top:5px;"><g fill="none"><g stroke="#050404"><path d="M1.2 2C1.1 2 1 2.1 1 2.3L1 24.8C1 24.9 1.1 25 1.3 25L23.8 25C23.9 25 24 24.9 24 24.8L24 13.5C24 13.4 24 13.4 23.9 13.3 23.9 13.3 23.8 13.2 23.8 13.2 23.7 13.2 23.6 13.3 23.6 13.3 23.5 13.4 23.5 13.4 23.5 13.5L23.5 24.5 1.5 24.5 1.5 2.5 12.5 2.5C12.6 2.5 12.7 2.5 12.7 2.5 12.8 2.4 12.8 2.3 12.8 2.3 12.8 2.2 12.8 2.1 12.7 2.1 12.7 2 12.6 2 12.5 2L1.3 2C1.3 2 1.2 2 1.2 2ZM16.7 2C16.6 2 16.5 2.1 16.5 2.3 16.5 2.4 16.6 2.6 16.8 2.5L23.2 2.5C23.1 2.5 23.1 2.6 23 2.6L10.7 14.9 10.7 14.9C10.7 15 10.6 15 10.6 15.1 10.6 15.2 10.7 15.3 10.7 15.3 10.8 15.4 10.8 15.4 10.9 15.4 11 15.4 11 15.4 11.1 15.3L23.4 3C23.4 3 23.5 2.9 23.5 2.9L23.5 9.2C23.5 9.3 23.5 9.4 23.6 9.4 23.6 9.5 23.7 9.5 23.8 9.5 23.8 9.5 23.9 9.5 23.9 9.4 24 9.4 24 9.3 24 9.2L24 2.3C24 2.1 23.9 2 23.8 2L16.8 2C16.8 2 16.8 2 16.7 2L16.7 2ZM23.3 2.5L23.5 2.5 23.5 2.7C23.5 2.6 23.4 2.6 23.3 2.5Z"/></g></g></svg>
          Links & Password
        </div>
        <div class="password">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="position:relative;top:5px;fill:none;stroke-linejoin:round;stroke-width:2;stroke:currentColor"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Your client can access the gallery and room upload with this password:
          <div class="secret">
            <copyable-text :data="secret">{{ secret }}</copyable-text>
          </div>
        </div>
        <div class="gallery-link">
          Gallery<br/>
          <copyable-text :data="galleryLink">
            <a :href="galleryLink" target="_blank">{{ galleryLink.substring(0, 25) }}...</a>
          </copyable-text>
          <a :href="mailGalleryLink" target="_blank">
            <div class="share-button">
              <div class="button-left">Share Gallery</div>
              <div class="button-right">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" style="position:relative;top:2px;"><g fill="none"><g fill="#FFF"><path d="M2.2 0C1 0 0 1 0 2.3L0 13.7C0 15 1 16 2.2 16L21 16C22.2 16 23.2 15 23.2 13.7L23.2 2.3C23.2 1 22.2 0 21 0L2.2 0ZM2.2 1.1L21 1.1C21.1 1.1 21.3 1.1 21.4 1.2L12.3 9.6C11.9 10 11.3 10 10.9 9.6L1.8 1.2C1.9 1.1 2 1.1 2.2 1.1L2.2 1.1ZM1.1 2.1L7.6 8.1 1.2 14.3C1.2 14.1 1.1 13.9 1.1 13.7L1.1 2.3C1.1 2.2 1.1 2.2 1.1 2.1L1.1 2.1ZM22.1 2.1C22.1 2.2 22.1 2.2 22.1 2.3L22.1 13.7C22.1 13.9 22 14.1 21.9 14.3L15.6 8.1 22.1 2.1ZM14.8 8.8L21 14.9 21 14.9 2.2 14.9 2.2 14.9 8.4 8.8 10.1 10.5C11 11.2 12.2 11.2 13.1 10.5L14.8 8.8Z"/></g></g></svg>
              </div>
            </div>
          </a>
        </div>
        <div class="room-upload-link">
          Room Upload<br/>
          <copyable-text :data="roomUploadLink">
            <a :href="roomUploadLink" target="_blank">{{ roomUploadLink.substring(0, 25) }}...</a>
          </copyable-text>
          <a :href="mailRoomUploadLink" target="_blank">
            <div class="share-button">
              <div class="button-left">Share Room Upload</div>
              <div class="button-right">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" style="position:relative;top:2px;"><g fill="none"><g fill="#FFF"><path d="M2.2 0C1 0 0 1 0 2.3L0 13.7C0 15 1 16 2.2 16L21 16C22.2 16 23.2 15 23.2 13.7L23.2 2.3C23.2 1 22.2 0 21 0L2.2 0ZM2.2 1.1L21 1.1C21.1 1.1 21.3 1.1 21.4 1.2L12.3 9.6C11.9 10 11.3 10 10.9 9.6L1.8 1.2C1.9 1.1 2 1.1 2.2 1.1L2.2 1.1ZM1.1 2.1L7.6 8.1 1.2 14.3C1.2 14.1 1.1 13.9 1.1 13.7L1.1 2.3C1.1 2.2 1.1 2.2 1.1 2.1L1.1 2.1ZM22.1 2.1C22.1 2.2 22.1 2.2 22.1 2.3L22.1 13.7C22.1 13.9 22 14.1 21.9 14.3L15.6 8.1 22.1 2.1ZM14.8 8.8L21 14.9 21 14.9 2.2 14.9 2.2 14.9 8.4 8.8 10.1 10.5C11 11.2 12.2 11.2 13.1 10.5L14.8 8.8Z"/></g></g></svg>
              </div>
            </div>
          </a>
        </div>
      </div>

    </div>

    <div v-if="updateContact" class="modal-overlay" @click="updateContact = false">
      <div class="modal-content update-contact">
        <update-contact :contact="project.contact" :project-name="project.name" @close="updateContact = false"/>
      </div>
    </div>

    <div class="file-upload-area">
      <file-upload :projectName="projectName" @upload-complete="refresh"/>
    </div>

  </div>
</template>

<script>
import projectService from '@/services/project-service.js'
import { URLify, deURLify } from '@/utils/urlify.js'
import CopyableText from '@/components/utility/CopyableText.vue'
import FileUpload from '@/components/utility/FileUpload.vue'
import UpdateContact from '@/components/projects/UpdateContact.vue'

export default {
  name: 'ProjectDetailsMobile',
  components: {
    CopyableText,
    FileUpload,
    UpdateContact,
  },
  data() {
    return {
      projectName: '',

      secret: '',

      updateContact: false,

      showDeleteConfirm: false,

      loading: false,
      err: null
    }
  },
  created() {
    this.projectName = deURLify(this.$route.params.project)
  },
  mounted() {
    if(!this.project) {
      this.$router.push('/projects')
      return
    }
    projectService.getSecret(this.project.name)
      .then((secret) => this.secret = secret)
  },
  methods: {
    gotoGallery() {
      this.$router.push({ path: '/gallery/'+this.projectPath })
    },
    gotoPresenterView() {
      this.$router.push({ path: '/presenter/'+this.projectPath })
    },
    refresh() {
      this.$store.dispatch('getAccessURLs', this.projectName)
    },
  },
  computed: {
    project() {
      return this.$store.getters.projects.find(p => p.name == this.projectName)
    },
    clientEmail() {
      if(this.project && this.project.contact && this.project.contact.email)
        return this.project.contact.email
      return 'client@email.com'
    },
    user() {
      return this.$store.getters.user
    },
    projectPath() {
      return URLify(this.user.email + '/' + this.project.name)
    },
    galleryLink() {
      return URLify('https://app.simplystudio.com/gallery/'+this.user.email+'/'+this.project.name)
    },
    roomUploadLink() {
      return URLify('https://app.simplystudio.com/room-upload/'+this.user.email+'/'+this.project.name)
    },
    mailGalleryLink() {
      const subject = 'Your Photo Gallery'
      const body = 'Hello!\n\nHere is the link to your photo gallery: \n\n' + this.galleryLink + '\n\n'
       + 'The password is: ' + this.secret
      return 'mailto:' + this.clientEmail + '?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body)
    },
    mailRoomUploadLink() {
      const subject = 'Your Photo Gallery'
      const body = 'Hello!\n\nHere is the link to your room upload: \n\n' + this.roomUploadLink + '\n\n'
       + 'The password is: ' + this.secret
      return 'mailto:' + this.clientEmail + '?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.details {
  padding: 50px;
  text-align: left;

  .project-name {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .created {
    color: $secondaryText;
    font-size: 12px;
  }

  .navigation {
    div {
      position: relative;
      left: -15px;
      height: 40px;
      line-height: 40px;
      border-left: 4px solid transparent;
      padding-left: 10px;
      cursor: pointer;
      transition: 0.2s all;

      &:hover {
        border-left: 4px solid $primary;
      }
    }
  }

  .contact {

    .contact-header {
      position: relative;
      font-weight: 700;
      margin: 20px 0px;
      cursor: pointer;
    
      .edit-contact-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        color: $primary;
        opacity: 0;
        transition: 0.2s opacity;
      }

      &:hover {
        .edit-contact-icon {
          opacity: 1;
        }
      }
    }

    .contact-item {
      display: flex;
      margin-bottom: 10px;

      .icon {
        width: 40px;
      }
      .content {
        flex: 1;

        .label {
          color: $secondaryText;
          font-size: 14px;
        }

        .value {
          font-weight: 500;
        }
      }
    }

    a {
      color: inherit;
    }
  }

  .links {
    .links-header {
      font-weight: 700;
      margin: 20px 0px;
    }

    .password {
      color: $secondaryText;
      font-size: 14px;
      margin-bottom: 20px;

      .secret {
        color: $primaryText;
        font-size: 16px;
        font-weight: bold;
        // font-size: 18px;
        color: $primary;
        padding: 10px;
        text-shadow: 1px 1px 2px rgba($secondaryText, 0.2);
        box-shadow: 2px 2px 10px rgba(black, 0.2);
        border-radius: 3px;
        margin-top: 10px;
      }
    }

    .gallery-link, .room-upload-link {
      color: $secondaryText;
      margin-bottom: 20px;
    }

    .share-button {
      display: flex;
      height: 50px;
      line-height: 50px;
      box-shadow: 2px 2px 10px rgba(black, 0.2);
      border-radius: 3px;
      overflow: hidden;
      margin: 10px 0px;
      cursor: pointer;
      color: $primaryText;

      &:hover {
        box-shadow: 2px 2px 10px rgba(black, 0.4);
      }

      .button-left {
        flex: 1;
        padding-left: 15px;
      }
      .button-right {
        background-color: $primary;
        width: 50px;
        text-align: center;
      }
    }
  }

  .manage-project {
    .manage-header {
      font-weight: 700;
      margin: 20px 0px;
    }

    .manage-content {
      .delete-icon {
        float: right;
        cursor: pointer;
        &:hover {
          color: $red;
        }
      }
    }
  }

  .separator {
    width: 100%;
    height: 1px;
    background-color: $separator;
    margin: 30px 0px;
  }
}

.update-contact {
  width: 90vw;
  background-color: white;
}

.file-upload-area {
  height: 180px;
  background-color: white;
  margin: 30px;
}
</style>